<template>
  <div class="all">
    <div class="header">
      <div>
        "大众评公务"满意度调查问卷
      </div>
      <div>
        <button v-if="!showToast" @click="toUpload">提交</button>
        <button v-if="showToast">提交</button>
      </div>
    </div>
    <div class="nav">
      <div class="navList">
        <ul>
          <li
            class="che-box"
            v-for="(item, index) in departList"
            :key="index"
            @click="toChoose(index)"
            :class="{
              'checked-box': chooseIndex == index,
              'depart-checked': item.checked == true
            }"
          >
            {{ item.department_name }}
          </li>
        </ul>
      </div>
      <div class="bottomList">
        <div class="list">
          <div class="listLeft">评价<span>(全选)</span></div>
          <div class="listRight">
            <div
              class=""
              v-for="(fItem, fIndex) in footFList"
              :key="fIndex"
              :class="chooseAllIndex == fIndex ? 'bottom-checked' : ''"
              @click="toChooseAll(fIndex)"
            >
              <span>{{ fItem.option_name }}</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="listLeft">支持基层发展</div>
          <div class="listRight">
            <div
              class=""
              v-for="(fItem, fIndex) in footFList"
              :key="fIndex"
              :class="chooseFIndex == fIndex ? 'bottom-checked' : ''"
              @click="toChooseF(fIndex)"
            >
              <span>{{ fItem.option_name }}</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="listLeft">开展业务指导</div>
          <div class="listRight">
            <div
              class=""
              v-for="(fItem, fIndex) in footSList"
              :key="fIndex"
              :class="chooseSIndex == fIndex ? 'bottom-checked' : ''"
              @click="toChooseS(fIndex)"
            >
              <span>{{ fItem.option_name }}</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="listLeft">改作风提效率</div>
          <div class="listRight">
            <div
              class=""
              v-for="(tItem, tIndex) in footTList"
              :key="tIndex"
              :class="chooseTIndex == tIndex ? 'bottom-checked' : ''"
              @click="toChooseT(tIndex)"
            >
              <span>{{ tItem.option_name }}</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="listLeft">综合评价</div>
          <div class="listRight">
            <div
              class=""
              v-for="(foItem, foIndex) in footFoList"
              :key="foIndex"
              :class="chooseFoIndex == foIndex ? 'bottom-checked' : ''"
              @click="toChooseFo(foIndex)"
            >
              <span>{{ foItem.option_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toast" v-if="showToast">{{ toastText }}</div>

    <!--外层的遮罩 点击事件用来关闭弹窗，isShow控制弹窗显示 隐藏的props-->
    <div class="dialog-cover back" v-if="isShow" @click="closeMyself"></div>
    <!-- transition 这里可以加一些简单的动画效果 -->
    <transition name="drop">
      <!--style 通过props 控制内容的样式  -->
      <div class="dialog-content" v-if="isShow">
        <div class="dialog_head back">
          提示信息
        </div>
        <div class="dialog_main">
          是否评价完全部单位
        </div>
        <!--弹窗关闭按钮-->
        <div class="foot_close">
          <div class="close_img back" @click="toBack">继续填写</div>
          <div class="close_img blue-text" @click="toConfirm">确认</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import wx from "weixin-js-sdk";

  export default {
    data() {
      return {
        footFList: [],
        footSList: [],
        footTList: [],
        footFoList: [],
        departList: [],
        timeOut: 0,
        chooseIndex: -1,
        chooseFIndex: -1,
        chooseSIndex: -1,
        chooseTIndex: -1,
        chooseFoIndex: -1,
        chooseAllIndex: -1,
        user: null,
        regionId: null,
        showToast: false,
        toastText: "",
        otherList: [],
        uploadList: [
          {
            department_id: "",
            answer: [
              {
                question_id: 1,
                option_id: ""
              },
              {
                question_id: 2,
                option_id: ""
              },
              {
                question_id: 3,
                option_id: ""
              },
              {
                question_id: 4,
                option_id: ""
              }
            ]
          }
        ],
        isShow: false,
        ymd_name: '',
        submitList: []
      };
    },
    created() {
      this.ymd_name = localStorage.getItem("zf_xj_dcwj_ymd_name");
      let submitList = localStorage.getItem("zf_xj_submit_list");
      if (submitList) {
        this.submitList = JSON.parse(submitList)
      }
      let index = this.submitList.indexOf(this.ymd_name);
      if (index > -1) {
        this.showToast = true;
        this.toastText = "您已经提交过此问卷！";
        this.timeOut = setTimeout(() => {
          this.showToast = false;
          if (/MicroMessenger/i.test(navigator.userAgent)) {
            wx.closeWindow();
          } else {
            this.$router.push("/");
          }
        }, 2000);
      }

      this.getDepartList();
      let userF = localStorage.getItem("userF");
      this.user = userF;
      if (!userF) {
        this.$router.push("/home");
      }
      let abc = localStorage.getItem("addressF");
      if (abc) {
        abc = JSON.parse(abc);
        this.regionId = abc.id;
      }
    },
    methods: {
      getDepartList() {
        this.$axios({
          url: "https://dk.jxbashen.com:82/api/index",
          method: "get",
          params: {}
        }).then(res => {
          res = res.data;

          res.depart.forEach(i => {
            i.checked = false;
          });

          this.departList = res.depart;
          this.otherList = res.question;
          console.log(res.question);
          this.uploadList = [];
          res.depart.forEach(i => {
            this.uploadList.push({
              department_id: i.department_id,
              answer: [
                {
                  question_id: 1,
                  option_id: 4
                },
                {
                  question_id: 2,
                  option_id: 8
                },
                {
                  question_id: 3,
                  option_id: 12
                },
                {
                  question_id: 4,
                  option_id: 16
                }
              ]
            });
          });

          this.footFList = res.question[0].option;
          this.footSList = res.question[0].option;
          this.footTList = res.question[0].option;
          this.footFoList = res.question[0].option;
        });
      },

      toChoose(index) {
        this.chooseAllIndex = -1;
        this.chooseIndex = index;

        this.departList[index].checked = true;

        if (this.uploadList[index].answer[0].option_id == 1) {
          this.chooseFIndex = 0;
        } else if (this.uploadList[index].answer[0].option_id == 2) {
          this.chooseFIndex = 1;
        } else if (this.uploadList[index].answer[0].option_id == 3) {
          this.chooseFIndex = 2;
        } else if (this.uploadList[index].answer[0].option_id == 4) {
          this.chooseFIndex = 3;
        }

        if (this.uploadList[index].answer[1].option_id == 5) {
          this.chooseSIndex = 0;
        } else if (this.uploadList[index].answer[1].option_id == 6) {
          this.chooseSIndex = 1;
        } else if (this.uploadList[index].answer[1].option_id == 7) {
          this.chooseSIndex = 2;
        } else if (this.uploadList[index].answer[1].option_id == 8) {
          this.chooseSIndex = 3;
        }

        if (this.uploadList[index].answer[2].option_id == 9) {
          this.chooseTIndex = 0;
        } else if (this.uploadList[index].answer[2].option_id == 10) {
          this.chooseTIndex = 1;
        } else if (this.uploadList[index].answer[2].option_id == 11) {
          this.chooseTIndex = 2;
        } else if (this.uploadList[index].answer[2].option_id == 12) {
          this.chooseTIndex = 3;
        }

        if (this.uploadList[index].answer[3].option_id == 13) {
          this.chooseFoIndex = 0;
        } else if (this.uploadList[index].answer[3].option_id == 14) {
          this.chooseFoIndex = 1;
        } else if (this.uploadList[index].answer[3].option_id == 15) {
          this.chooseFoIndex = 2;
        } else if (this.uploadList[index].answer[3].option_id == 16) {
          this.chooseFoIndex = 3;
        }

        if (this.chooseTIndex == this.chooseFoIndex) {
          if (this.chooseTIndex == this.chooseSIndex) {
            if (this.chooseTIndex == this.chooseFIndex) {
              this.chooseAllIndex = this.chooseTIndex;
            } else {
              this.chooseAllIndex = -1;
            }
          } else {
            this.chooseAllIndex = -1;
          }
        } else {
          this.chooseAllIndex = -1;
        }
      },
      toChooseF(index) {
        this.chooseFIndex = index;
        this.uploadList[
          this.chooseIndex
          ].answer[0].option_id = this.otherList[0].option[index].option_id;

        if (this.chooseFIndex == this.chooseFoIndex) {
          if (this.chooseFIndex == this.chooseTIndex) {
            if (this.chooseFIndex == this.chooseSIndex) {
              this.chooseAllIndex = index;
            } else {
              this.chooseAllIndex = -1;
            }
          } else {
            this.chooseAllIndex = -1;
          }
        } else {
          this.chooseAllIndex = -1;
        }
      },
      toChooseS(index) {
        this.chooseSIndex = index;

        this.uploadList[
          this.chooseIndex
          ].answer[1].option_id = this.otherList[1].option[index].option_id;

        if (this.chooseSIndex == this.chooseFoIndex) {
          if (this.chooseSIndex == this.chooseTIndex) {
            if (this.chooseSIndex == this.chooseFIndex) {
              this.chooseAllIndex = index;
            } else {
              this.chooseAllIndex = -1;
            }
          } else {
            this.chooseAllIndex = -1;
          }
        } else {
          this.chooseAllIndex = -1;
        }
      },
      toChooseT: function (index) {
        console.log(index);
        this.chooseTIndex = index;

        this.uploadList[
          this.chooseIndex
          ].answer[2].option_id = this.otherList[2].option[index].option_id;

        if (this.chooseTIndex == this.chooseFoIndex) {
          if (this.chooseTIndex == this.chooseSIndex) {
            if (this.chooseTIndex == this.chooseFIndex) {
              this.chooseAllIndex = index;
            } else {
              this.chooseAllIndex = -1;
            }
          } else {
            this.chooseAllIndex = -1;
          }
        } else {
          this.chooseAllIndex = -1;
        }
      },
      toChooseFo(index) {

        this.chooseFoIndex = index;
        this.uploadList[
          this.chooseIndex
          ].answer[3].option_id = this.otherList[3].option[index].option_id;

        if (this.chooseFoIndex == this.chooseTIndex) {
          if (this.chooseFoIndex == this.chooseSIndex) {
            if (this.chooseFoIndex == this.chooseFIndex) {
              this.chooseAllIndex = index;
            } else {
              this.chooseAllIndex = -1;
            }
          } else {
            this.chooseAllIndex = -1;
          }
        } else {
          this.chooseAllIndex = -1;
        }
      },
      toChooseAll(index) {
        if (this.chooseIndex == -1) {
          this.showToast = true;
          this.toastText = "请先选择部门";
          this.timeOut = setTimeout(() => {
            this.showToast = false;
          }, 1500);
          return;
        }

        this.chooseAllIndex = index;
        if (index == 0) {
          this.uploadList[this.chooseIndex].answer.forEach((i, j) => {
            i.option_id = this.otherList[j].option[0].option_id;
          });
        } else if (index == 1) {
          this.uploadList[this.chooseIndex].answer.forEach((i, j) => {
            i.option_id = this.otherList[j].option[1].option_id;
          });
        } else if (index == 2) {
          this.uploadList[this.chooseIndex].answer.forEach((i, j) => {
            i.option_id = this.otherList[j].option[2].option_id;
          });
        } else if (index == 3) {
          this.uploadList[this.chooseIndex].answer.forEach((i, j) => {
            i.option_id = this.otherList[j].option[3].option_id;
          });
        }

        this.chooseFoIndex = index;
        this.chooseTIndex = index;
        this.chooseSIndex = index;
        this.chooseFIndex = index;
      },

      toUpload() {
        // this.WeixinJSBridge.call('closeWindow');
        this.isShow = true;
        // http://121.37.207.158:82/answer
      },
      toBack() {
        this.isShow = false;
      },
      closeMyself() {
        this.isShow = false;
      },
      toConfirm() {
        this.isShow = false;
        let index = this.submitList.indexOf(this.ymd_name);
        if (index > -1) {
          this.toastText = "您已经提交过此问卷！";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 1500);
          return false
        }
        this.showToast = true;
        this.toastText = "提交中...";
        let upData = {
          data: this.uploadList,
          user: this.user,
          region_id: this.regionId
        };
        this.$axios({
          url: "https://dk.jxbashen.com:82/api/answer",
          method: "post",
          data: upData
        }).then(res => {
          if (res.data.status == 1) {
            this.showToast = true;
            this.toastText = "提交成功";
            this.submitList.push(this.ymd_name);
            localStorage.setItem("zf_xj_submit_list", JSON.stringify(this.submitList));
            this.timeOut = setTimeout(() => {
              this.showToast = false;
              if (/MicroMessenger/i.test(navigator.userAgent)) {
                wx.closeWindow();
              } else {
                this.$router.push("/");
              }
            }, 1500);
          }
        }).catch(err => {
          console.log(err);
        });
      }
    }
  };
</script>
<style scoped>
  body {
    margin: 0;
    padding: 0;
    width: 100vw;
    background-color: #f4f4f4;
  }

  .header {
    padding: 0 3%;
    height: 7.5rem;
    font-size: 3rem;
    line-height: 7.5rem;
    background: rgba(255, 255, 255, 1);
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    width: 94%;
  }

  .header button {
    padding: 0 2rem;
    height: 4rem;
    background-color: #1d83ec;
    color: white;
    font-size: 2.5rem;
    line-height: 4rem;
    border: none;
    margin-top: 0;
  }

  .nav {
    height: 100%;
    margin-top: 7.5rem;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  .all {
    position: relative;
  }

  .toast {
    position: fixed;
    top: 50%;
    width: 50%;
    left: 25%;
    background-color: rgba(0, 0, 0, 0.8);
    height: 6rem;
    z-index: 999;
    color: #fff;
    font-size: 2rem;
    line-height: 6rem;
    border-radius: 20px;
  }

  li {
    list-style-type: none;
    height: 4.5rem;
    background-color: #f4f4f4;
    line-height: 4.5rem;
    font-family: "SourceHanSansCN-Regular";
    font-size: 2.25rem;
    border: none;
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  }

  .depart-checked {
    /*background-color: #1d83ec;*/
    color: #1d83ec;
  }

  .checked-box {
    background-color: #1d83ec;
    color: #fff;
  }

  .listRight .bottom-checked {
    background-color: #1d83ec;
  }

  .listRight .bottom-checked span {
    color: #fff;
  }

  .navList {
    margin-bottom: 32rem;
  }

  .bottomList {
    height: 31.25rem;
    width: 100%;
    background-color: #f4f4f4;
    position: fixed;
    bottom: 0;
  }

  .bottomList .list {
    margin-bottom: 2px;
    background-color: #fff;
  }

  .bottomList .list:last-child {
    margin-bottom: 0;
  }

  .bottomList > div {
    height: 6.25rem;
    line-height: 6.25rem;
    font-size: 1.75rem;
  }

  .listLeft {
    width: 17rem;
    padding-left: 1.25rem;
    font-weight: 500;
    color: #000000;
    font-size: 2.25rem;
  }

  .listRight {
    display: flex;
    justify-content: space-around;
    width: calc(100% - 13.75rem);
  }

  .listRight > div {
    height: 3.75rem;
    width: 8rem;
    background: rgba(244, 244, 244, 1);
    text-align: center;
    line-height: 3.75rem;
    margin-top: 1.25rem;
    border-radius: 4px;
  }

  .list {
    display: flex;
    justify-content: start;
  }

  .listRight span {
    color: #969696;
    font-size: 2.25rem;
  }

  .listLeft span {
    color: #969696;
    font-size: 1.75rem;
  }

  .tabs {
    background: #1d83ec;
    color: #ffffff;
  }

  ul li:focus {
    background-color: #1d83ec;
    color: #ffffff;
  }

  /*  .che-box {
                                                                                                                                display:inline;
                                                                                                                            } */
  .che-box {
    /*display: none;*/
    /*position: relative;*/
    /*width: 100vw;*/
    /*height: 100%;*/
    /*border: 1px solid red;*/
    text-align: left;
  }

  .che-box input:checked + label {
    border-color: #088de8;
    background: #088de8;
    color: #fff;
  }

  .dialog-cover {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .dialog-content {
    position: fixed;
    top: 35%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 300;
    left: 10vw;
    width: 80vw;
    /*height: 20vh;*/
    border-radius: 20px;
    background-color: #fff;
    color: #000;
    font-size: 3rem;
  }

  .dialog_head {
    margin: 2rem 0 3rem;
  }

  .dialog_main {
    width: 100%;
    font-size: 2.5rem;
    margin-bottom: 3rem;
  }

  .foot_close {
    /*padding: 1rem 0 2rem;*/
    display: flex;
    justify-content: space-around;
    width: 100%;
    border-top: 1px solid #a2a2a2;
    height: 8rem;
    align-items: center;
  }

  .close_img {
    border-right: 1px solid #a2a2a2;
    width: 50%;
    font-size: 2.5rem;
  }

  .blue-text {
    color: #1d83ec;
  }
</style>
